import { render, staticRenderFns } from "./SysNcTemplateManager.vue?vue&type=template&id=3b019324&scoped=true&"
import script from "./SysNcTemplateManager.vue?vue&type=script&lang=js&"
export * from "./SysNcTemplateManager.vue?vue&type=script&lang=js&"
import style0 from "./SysNcTemplateManager.vue?vue&type=style&index=0&id=3b019324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b019324",
  null
  
)

export default component.exports